import { Cubby, ParametricPart, Section } from "../domain";
import { approx, approxGreaterThan, approxGteq, round2slot } from "../measurement";


/**
 * Finds the global elevation of the fixed shelves above and below the given
 * elevation, y. This should only be called when canAcceptCubby has returned
 * true for the given section and value of y.
 */
export const getCubbySpan = (section: Section, y: number): [y: number, height: number] => {
    let
        below: ParametricPart = null,
        above: ParametricPart = null;
    for(const part of section.parametricParts) {
        if(part.name.startsWith('Fixed')) {
            if(approx(part.position.y, y)) {
            } else if(approxGteq(y, part.position.y)) {
                below = part;
            } else if(above == null && approxGreaterThan(part.position.y, y)) {
                above = part;
            }
        }
    }

    return [below.position.y + 3/8,
            above.position.y - below.position.y - above.height];
};


export const resizeCubbyByFixedShelf = (shelf: ParametricPart, section: Section, y: number) => {
    for(const cubby of section.cubbies) {
        const
            bottom = cubby.position.y - 3/8,
            top = bottom + cubby.height + shelf.height;
        if(approx(bottom, shelf.position.y)) {
            cubby.position.y = y + 3/8;
            cubby.height = top - y - shelf.height;
        }
        if(approx(top, shelf.position.y)) {
            cubby.height = y - bottom - shelf.height;
        }
    }
};


type AdjacentCubbies = [above: Cubby|null, below: Cubby|null];

/**
 * Returns a two-tuple of CubbyViews if a cubby exists directly above or below
 * the given shelf.
 */
export const getAdjacentCubbies = (section: Section, shelf: ParametricPart): AdjacentCubbies =>
{
    const
        y = round2slot(shelf.position.y),
        result: AdjacentCubbies = [null, null];

    for(const cubby of section.cubbies) {
        const
            bottom = cubby.position.y - 3/8,
            top = bottom + cubby.height + shelf.height;
        if(approx(bottom, y)) {
            result[0] = cubby;
        }
        else if(approx(top, y)) {
            result[1] = cubby;
        }
    }

    return result;
}

